import '.an{max-width:1280px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bj{gap:144px;}.ssr-plugin'
import '.bk{max-width:568px;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useContentQuery } from '../../ctx.js'
import { persistent } from '../../constants/index.js'
import { LinkNotes } from './LinkNotes.js'
import { useEffect } from 'react'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'

export const Privacy = () => {
  const track = useTrack('privacy')

  const [lang] = useLanguage()
  const { legalGroupTitle, privacyPolicy, moreInfoReachOut } = useDictionary()
  const { data = '' } = useContentQuery('privacy', null, persistent)

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <styled.div className="an ap e m ao bj"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bk"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="bl">{legalGroupTitle}</h3>
          <h2 className="bm" style={{ color: colors.primary,}}>
            {privacyPolicy}
          </h2>
          <p className="bn">{moreInfoReachOut}</p>
          <LinkNotes />
        </styled.div>
        {/* column 2 */}
        <styled.div className="bo bk"
          dir="ltr"
          style={{
            '& h1': {
              fontSize: 'clamp(40px, 2.8vw, 56px)',
              marginBottom: '12px',
            },
            '& h2': {
              fontSize: 'clamp(22px, 2vw, 32px)',
              // @ts-ignore
              textAlign: 'left !important',
            },
            '& p': {
              margin: '1em 0em',
              // @ts-ignore
              textAlign: 'left !important',
            },
            '& ul': {
              fontSize: '16px',
              marginBottom: '12px',
            },
            '& li': {
              marginBottom: '6px',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: typeof data === 'string' ? data : '',
          }}
        ></styled.div>
      </styled.div>
    </Layout>
  )
}
